// extracted by mini-css-extract-plugin
export default {"editable-textbox__input":"Bua2XfauF6l1bttQ8O4t","editable-textbox__button":"yEIFC2Y6kLTeQUzW7OwT","editable-textbox__message":"wiM_VB1Eboxj9cHq5GeU"};